import type { LaunchDarklyContextEnrichment } from '@insurer-frontend/client-feature-flags';
import type { AppRouter as HeaderAppRouter } from '@insurer-frontend/header-trpc';
import { generateTrpcClientOptions } from '@insurer-frontend/trpc-client';
import { createTRPCClient } from '@trpc/client';

const LAUNCH_DARKLY_ENRICHMENT_TIMEOUT_MS = 3000;

/**
 * Calls the BFF to get attributes from the JWT for LaunchDarkly targeting.
 * Returns an empty object when the request fails or times out, and in test builds.
 * @returns The LaunchDarkly context enrichment attributes.
 */
export const fetchLaunchDarklyContextEnrichment =
    async (): Promise<LaunchDarklyContextEnrichment> => {
        if (__TESTING__) {
            return {};
        }

        const timeoutController = new AbortController();
        const timeoutId = setTimeout(
            () => timeoutController.abort(),
            LAUNCH_DARKLY_ENRICHMENT_TIMEOUT_MS,
        );

        try {
            const headerTrpcClient = createTRPCClient<HeaderAppRouter>(
                generateTrpcClientOptions('header'),
            );

            return await headerTrpcClient.getLaunchDarklyContext.query(undefined, {
                signal: timeoutController.signal,
            });
        } catch (error) {
            console.error('Failed to fetch LaunchDarkly context enrichment', error);
            return {};
        } finally {
            clearTimeout(timeoutId);
        }
    };
